import axios from 'axios';
axios.defaults.baseURL = 'https://tz.attamayyuz.or.tz/service/';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers.post['Accept'] = 'application/json;charset=utf-8';
axios.defaults.headers.common['kilaza'] =
    '$argon2i$v=19$m=65536,t=4,p=1$Wnh1WDVZL05DdG1NOEFISw$deVmVFXb+6nUbqFqlMsjXW6DFRtoIvCK20bwRgoLqDc';